/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowbrandcolors3Inputs */

const en_aiflowbrandcolors3 = /** @type {(inputs: Aiflowbrandcolors3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colours from your profile:`)
};

const de_aiflowbrandcolors3 = /** @type {(inputs: Aiflowbrandcolors3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farben aus deinem Profil:`)
};

/**
* | output |
* | --- |
* | "Colours from your profile:" |
*
* @param {Aiflowbrandcolors3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowbrandcolors3 = /** @type {((inputs?: Aiflowbrandcolors3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowbrandcolors3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowbrandcolors3(inputs)
	return de_aiflowbrandcolors3(inputs)
});
export { aiflowbrandcolors3 as "aiFlowBrandColors" }